import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import NavMobile from "./NavMobile";
import mflogo from "assets/img/mflogo.png";
import header1 from "assets/img/header1.png";
import header2 from "assets/img/header2.png";
import header3 from "assets/img/header3.png";
import header4 from "assets/img/header4.png";
import { HashLink } from "react-router-hash-link";
import headericon1 from "assets/img/headericon1 (1).png";
import headericon2 from "assets/img/headericon2 (1).png";
import headericon3 from "assets/img/headericon3 (1).png";
import facebookicon1 from "assets/img/facebookicon1.png";
import instagramicon1 from "assets/img/instagramicon1.png";

import retailmarket from "assets/img/Retail-market.jpg";
import fishmongers from "assets/img/Fish-Mongers.jpg";
import hotel from "assets/img/Hotels-Restaurants.jpg";
import institution from "assets/img/Institutions.jpg";
import manufacturer from "assets/img/Manufacturers.jpg";

// French translation import statements start
import { useTranslation } from "react-i18next";
import { useLanguage } from "components/Homepage/LanguageContext";
// French translation import statements end

const IndexNavbar2 = () => {
  // French translation import statements
  const { t } = useTranslation();
  const { changeLanguage } = useLanguage();
  // French translation import statements end

  const [scrolled, setScrolled] = useState(false);
  const [showAboutDropdown, setShowAboutDropdown] = useState(false);
  const dropdownTimerRef = useRef(null);

  const [showFirstStep, setShowFirstStep] = useState(false);

  const onClickClose = () => {
    setShowFirstStep(false);
    document.body.style.backgroundColor = "";
  };

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    document.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, [scrolled]);

  const handleAboutHover = () => {
    if (dropdownTimerRef.current) {
      clearTimeout(dropdownTimerRef.current);
    }
    setShowAboutDropdown(true);
  };

  const handleAboutLeave = () => {
    dropdownTimerRef.current = setTimeout(() => {
      setShowAboutDropdown(false);
    }, 200); // Adjust delay as needed
  };

  const handleDropdownEnter = () => {
    if (dropdownTimerRef.current) {
      clearTimeout(dropdownTimerRef.current);
    }
  };

  const handleDropdownLeave = () => {
    setShowAboutDropdown(false);
  };

  const handleLanguageChange = (lang) => {
    changeLanguage(lang); // Call changeLanguage function to switch language
  };

  return (
    <>
      <div
        className={`fixed z-50 w-full xl:block lg:block md:hidden hidden navbar ${
          scrolled ? "scrolled" : "bgggg"
        }`}
      >
        <div
          className={`flex justify-between items-center py-22 px-4 ${
            scrolled ? "text-black" : "text-white"
          }`}
        >
          <div className="container xl:px-24 md:px-0 px-4 mx-auto">
            <div className="justify-between flex">
              <div>
                <div className="flex">
                  <Link to="/homepage">
                    <img
                      src={mflogo}
                      className="xl:w-48 lg:w-44 xl:mt-5 lg:mt-5"
                    />
                  </Link>
                  <div></div>
                </div>
              </div>
              <div className="">
                <div className="flex justify-end ">
                  <div className="xl:w-5/12 lg:w-3/12 md:w-full mb-2 flex justify-end">
                    <div className="flex space-x-4">
                      <div className=" xl:ml-64 lg:ml-32 h-7 w-7 bg-newshade center-items rounded-md">
                        <a href="#" target="_blank" rel="noopener noreferrer">
                          <img
                            className=" w-5"
                            src={facebookicon1}
                            alt="Facebook icon"
                          />
                        </a>
                      </div>

                      <div className=" h-7 w-7 bg-newshade center-items xl:ml-2 lg:ml-2 rounded-md">
                        <a href="#" target="_blank" rel="noopener noreferrer">
                          <img
                            className="w-5"
                            src={instagramicon1}
                            alt="Instagram icon"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex gap-4 border-t-dark-blue">
                  <div className="flex mt-4 ml-12 gap-6">
                    <div
                      className="nav-link"
                      onMouseEnter={handleAboutHover}
                      onMouseLeave={handleAboutLeave}
                    >
                      <p className="text-header cursor-pointer">
                        <a href="/products">{t("navbar.head2")}</a>
                      </p>

                      {showAboutDropdown && (
                        <div
                          className="menu-dropdown bg-white  shadow-xl  border  xl:mr-max lg:mr-8 xl:-ml-20 lg:-ml-16 animate-slide-up absolute mt-2 xl:mt-4 lg:mt-4"
                          onMouseEnter={handleDropdownEnter}
                          onMouseLeave={handleDropdownLeave}
                        >
                          <div className="flex rounded-xl">
                            <div className="w-full xl:w-12/12 lg:w-12/12 md:w-12/12">
                              <div className="lg:w-12/12 md:w-6/12 xl:p-8 p-8">
                                <ul className="flex">
                                  <li className="border-r pr-4">
                                    <div className="flex flex-wrap pb-4">
                                      <div className="lg:w-2/12 md:w-3/12">
                                        <img
                                          className="xl:w-12  border-lightblue bg-light-sky p-2"
                                          src={headericon1}
                                          alt="..."
                                        />
                                      </div>
                                      <div className="lg:w-10/12 md:w-7/12">
                                        <HashLink
                                          smooth
                                          to="/products#cephalapodes"
                                        >
                                          <h1 className="font-bold xl:text-base1 lg:text-base text-left pl-3 head1 text-redd">
                                            {t("headercontent1")}
                                          </h1>
                                          <p className="banner-font pl-3 pt-1 text-sm text-greyy mr-2">
                                            {t("headercontent2")}
                                          </p>
                                        </HashLink>
                                      </div>
                                    </div>
                                  </li>

                                  <li className="pl-4">
                                    <div className="flex flex-wrap pb-4">
                                      <div className="lg:w-2/12 md:w-3/12">
                                        <img
                                          className="xl:w-12  border-lightblue bg-light-sky p-2"
                                          src={headericon2}
                                          alt="..."
                                        />
                                      </div>
                                      <div className="lg:w-10/12 md:w-7/12">
                                        <a href="/products">
                                          <h1 className="font-bold xl:text-base1 lg:text-base text-left pl-3 head1 text-redd">
                                            {t("headercontent3")}
                                          </h1>
                                          <p className="banner-font pl-3 pt-1 text-sm text-greyy">
                                            {t("headercontent4")}
                                          </p>
                                        </a>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                                <ul className="flex">
                                  <li className="border-r pr-4">
                                    <div className="flex flex-wrap pt-4">
                                      <div className="lg:w-2/12 md:w-3/12">
                                        <img
                                          className="xl:w-12 mt-2  border-lightblue bg-light-sky p-2"
                                          src={headericon3}
                                          alt="..."
                                        />
                                      </div>
                                      <div className="lg:w-10/12 md:w-7/12 pt-2">
                                        <a href="/products">
                                          <h1 className="font-bold xl:text-base1 lg:text-base text-left pl-3 head1 text-redd">
                                            {t("headercontent5")}
                                          </h1>
                                          <p className="banner-font pl-3 pt-1 text-sm text-greyy mr-2">
                                            {t("headercontent6")}
                                          </p>
                                        </a>
                                      </div>
                                    </div>
                                  </li>

                                  <li className="pl-4">
                                    <div className="flex flex-wrap pt-4">
                                      <div className="lg:w-2/12 md:w-3/12">
                                        <img
                                          className="xl:w-12 mt-2  border-lightblue bg-light-sky p-2"
                                          src={header4}
                                          alt="..."
                                        />
                                      </div>
                                      <div className="lg:w-10/12 md:w-7/12 pt-2">
                                        <a href="/products">
                                          <h1 className="font-bold xl:text-base1 lg:text-base text-left pl-3 head1 text-redd">
                                            {t("foodcontent23")}
                                          </h1>
                                          <p className="banner-font pl-3 pt-1 text-sm text-greyy mr-2">
                                            {t("headercontent7")}
                                          </p>
                                        </a>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <Link to="/quality" className="nav-link">
                      <p className="text-header">{t("Quality")}</p>
                    </Link>
                    <Link to="/service" className="nav-link">
                      <p className="text-header">{t("navbar.head4")}</p>
                    </Link>
                    <Link to="/about-us" className="nav-link">
                      <p className="text-header">{t("navbar.head3")}</p>
                    </Link>
                    <Link to="/contact-us" className="nav-link">
                      <p className="text-header">{t("navbar.head5")}</p>
                    </Link>
                  </div>
                  <button
                    className="text-header banner-font mt-3 ml-12 cursor-pointer no-outline"
                    onClick={() => handleLanguageChange("en")}
                  >
                    EN
                  </button>
                  <button
                    className="text-header banner-font mt-3 cursor-pointer no-outline"
                    onClick={() => handleLanguageChange("fr")}
                  >
                    FR
                  </button>

                  <Link to="/contact-us">
                    <p className="uppercase banner-font text-sm mt-3 text-blue-dark border-dark-blue onhover px-6 py-2">
                      {t("navbar.enquiry")}
                    </p>
                  </Link>
                  <div
                    className="pl-4 pt-3 font-bold xl:text-2xl cursor-pointer text-blue-dark rounded-md"
                    onClick={() => setShowFirstStep(true)}
                  >
                    ☰
                  </div>
                  {showFirstStep && (
                    <div className="fixed xl:inset-1 z-50 animate-slide-right flex justify-end">
                      <div
                        style={{
                          // backgroundImage:
                          //   "url('https://i.ibb.co/4ZqKWK4/swimming-pool-texture-watercolour-background-1048-6490.jpg')",
                          backgroundColor: "#160935",
                          backgroundPosition: "fixed",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                        }}
                        className="xl:py-6 xl:px-6 lg:px-6 lg:py-6 h-full w-full lg:w-8/12 xl:w-8/12 "
                      >
                        <div className="flex justify-between">
                          <div></div>
                          <div
                            onClick={onClickClose}
                            className="text-white cursor-pointer font-extrabold"
                          >
                            ✕
                          </div>
                        </div>
                        <div className="flex flex-col py-2 md:py-0 px-6 space-y-1">
                          <div>
                            <div className="  ">
                              <div>
                                <h1 className="uppercase font-semibold banner-font text-white xl:text-head1 lg:text-head1 md:text-head1 text-head1   ">
                                  {" "}
                                  We distribute
                                </h1>

                                <div>
                                  <div className="flex  justify-start xl:mt-4 lg:mt-4">
                                    <div className="">
                                      <img
                                        class="w-24 rounded-md mt-1"
                                        src={retailmarket}
                                        alt=""
                                      />
                                    </div>
                                    <div className="xl:ml-6 lg:ml-4">
                                      <h1 className="xl:text-base1 text-white font-bold lg:text-base1">
                                        Retail Markets
                                      </h1>
                                      <p className="xl:text-base text-white pt-1 lg:text-base">
                                        We distribute a wide range of seafood to
                                        all retail markets.
                                      </p>
                                    </div>
                                  </div>

                                  <div className="flex  justify-start xl:mt-4 lg:mt-4">
                                    <div className="">
                                      <img
                                        class="w-24 rounded-md mt-1"
                                        src={fishmongers}
                                        alt=""
                                      />
                                    </div>
                                    <div className="xl:ml-6 lg:ml-4">
                                      <h1 className="xl:text-base1 text-white font-bold lg:text-base1">
                                        Fish Mongers
                                      </h1>
                                      <p className="xl:text-base text-white pt-1 lg:text-base">
                                        We supply a wide range of seafood to all
                                        fishmongers.
                                      </p>
                                    </div>
                                  </div>

                                  <div className="flex  justify-start xl:mt-4 lg:mt-4">
                                    <div className="">
                                      <img
                                        class="w-32 rounded-md mt-1"
                                        src={hotel}
                                        alt=""
                                      />
                                    </div>
                                    <div className="xl:ml-6 lg:ml-4">
                                      <h1 className="xl:text-base1 text-white font-bold lg:text-base1">
                                        Hotels & Restaurants
                                      </h1>
                                      <p className="xl:text-base text-white pt-1 lg:text-base">
                                        We provide fresh, high-quality seafood
                                        to the Hotels & Restaurants
                                      </p>
                                    </div>
                                  </div>

                                  <div className="flex  justify-start xl:mt-4 lg:mt-4">
                                    <div className="">
                                      <img
                                        class="w-24 rounded-md mt-1"
                                        src={institution}
                                        alt=""
                                      />
                                    </div>
                                    <div className="xl:ml-6 lg:ml-4">
                                      <h1 className="xl:text-base1 text-white font-bold lg:text-base1">
                                        Institutions
                                      </h1>
                                      <p className="xl:text-base text-white pt-1 lg:text-base">
                                        We deliver premium seafood to
                                        institutional clients
                                      </p>
                                    </div>
                                  </div>

                                  <div className="flex  justify-start xl:mt-4 lg:mt-4">
                                    <div className="">
                                      <img
                                        class="w-36 rounded-md mt-1"
                                        src={manufacturer}
                                        alt=""
                                      />
                                    </div>
                                    <div className="xl:ml-6 lg:ml-4">
                                      <h1 className="xl:text-base1 text-white font-bold lg:text-base1">
                                        Manufacturers
                                      </h1>
                                      <p className="xl:text-base text-white pt-1 lg:text-base">
                                        We are a leading exporter of fresh
                                        seafood to the manufacturing industry.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="flex justify-start xl:mt-4 xl:ml-4 lg:mt-8 xl:pb-4 lg:pb-8 ">
                              <div className="">
                                <a
                                  href="#"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <img
                                    className=" w-6 "
                                    src={facebookicon1}
                                    alt="Facebook icon"
                                  />
                                </a>
                              </div>

                              <div>
                                <a
                                  href="#"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <img
                                    className="w-6 xl:ml-2 lg:ml-4 "
                                    src={instagramicon1}
                                    alt="Instagram icon"
                                  />
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      <div className="xl:hidden lg:hidden md:block">
        <NavMobile />
      </div>
    </>
  );
};

export default IndexNavbar2;
